import React, { useState } from 'react';
import './Login.css';
import { Link, useHistory } from 'react-router-dom';
import { auth } from '../../assets/js/firebase';
var firebase = require('firebase');

function Login() {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [registerUser, setRegisterUser] = useState(false);

  const signIn = (event) => {
    event.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        signInRegisterRedirect(auth);
      })
      .catch((error) => alert(error.message));
  };

  const register = (event) => {
    event.preventDefault();
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        let currentUser = firebase.auth().currentUser;
        currentUser
          .updateProfile({
            displayName: `${firstName} ${lastName}`,
          })
          .then(() => {
            signInRegisterRedirect(auth);
            if (auth) {
              history.push('/');
            }
          })
          .catch(function (error) {
            alert(error.message);
          });
      })
      .catch((error) => alert(error.message));
  };

  const signInRegisterRedirect = (auth) => {
    if (auth) {
      if (sessionStorage['returnURL']) {
        history.push(sessionStorage['returnURL']);
        sessionStorage.removeItem('returnURL');
      } else {
        history.push('/');
      }
    }
  };

  const toggleRegisterUser = (event) => {
    event.preventDefault();
    setRegisterUser(!registerUser);
  };

  return (
    <div className="login">
      <Link to="/">
        <img
          className="login__logo"
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png"
          alt=""
        />
      </Link>
      <div className="login__container">
        <h1>{registerUser === false ? 'Sign In' : 'Create An Account'}</h1>
        <form>
          <h5>E-mail</h5>
          <input
            type="text"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <h5>Password</h5>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          {registerUser === false ? null : (
            <div>
              <h5>First Name</h5>
              <input
                type="text"
                value={firstName}
                onChange={(event) => setFirstName(event.target.value)}
              />
              <h5>Last Name</h5>
              <input
                type="text"
                value={lastName}
                onChange={(event) => setLastName(event.target.value)}
              />
            </div>
          )}
          {registerUser === false && (
            <button
              type="submit"
              onClick={signIn}
              className="login__signInButton app__button"
            >
              Sign In
            </button>
          )}
        </form>
        {registerUser === true && (
          <button onClick={register} className="login__registerButton">
            Create your Amazon Account
          </button>
        )}
        {registerUser === false ? (
          <p className="login__registerUserLink">
            Not A User?{' '}
            <a href="true" onClick={toggleRegisterUser}>
              Create An Account
            </a>
          </p>
        ) : (
          <p className="login__registerUserLink">
            Already A User?{' '}
            <a href="true" onClick={toggleRegisterUser}>
              Sign In
            </a>
          </p>
        )}
        <p>
          By signing-in you agree to AMAZON FAKE CLONE Conditions of Use & Sale.
          Please see our Privacy Notice, our Cookies Notice and our
          Interest-Based Ads Notice.
        </p>
      </div>
    </div>
  );
}

export default Login;
